import DashboardSkeletons from './DashboardSkeletons';

export default DashboardSkeletons;
